// Contenus SEO (propriété du pôle SEO). Les constantes viennent de lib/site.ts.
export { SITE_URL, EMAIL, LINKEDIN_URL, LOGO_URL, OG_IMAGE, REGION } from './site';

export const DEPARTEMENTS = [
	'Paris',
	'Seine-et-Marne',
	'Yvelines',
	'Essonne',
	'Hauts-de-Seine',
	'Seine-Saint-Denis',
	'Val-de-Marne',
	"Val-d'Oise",
];

export type ServicePageData = {
	slug: string;
	name: string; // nom court (breadcrumb, schéma)
	h1: string;
	metaTitle: string;
	metaDescription: string;
	intro: string;
	detail: string;
	listTitle: string;
	list: string[];
	projectsTitle: string;
	projects: { name: string; text: string }[];
	approach: string;
	faq: { q: string; a: string }[];
};

export const SERVICE_PAGES: ServicePageData[] = [
	{
		slug: 'developpement-application-web',
		name: "Développement d'applications web",
		h1: "Développement d'applications web en Île-de-France",
		metaTitle: "Développement d'applications web en Île-de-France",
		metaDescription:
			"Kuba Studio conçoit des applications web, sites et dashboards sur mesure en Île-de-France : Next.js, React, TypeScript, SEO et performance. Parlons de votre projet.",
		intro:
			"Kuba Studio conçoit des applications web, sites et plateformes en ligne sur mesure pour les entreprises, associations et porteurs de projet d'Île-de-France. Nous travaillons avec Next.js, React, TypeScript et Tailwind CSS pour livrer des interfaces modernes, rapides et pensées pour durer.",
		detail:
			"Que vous ayez besoin d'un site vitrine, d'un espace client, d'un tableau de bord interne ou d'une plateforme complète, nous construisons une base technique propre, facile à faire évoluer. Chaque projet est suivi de bout en bout par la même équipe, de la conception à la mise en ligne, avec un code documenté et testé.",
		listTitle: 'Ce que nous réalisons',
		list: ['Applications Next.js et React', 'Single Page Applications', 'Dashboards et backoffices', 'SEO et performance'],
		projectsTitle: 'Des réalisations concrètes',
		projects: [
			{ name: 'Patrol', text: "site web d'une entreprise de sécurité privée et de surveillance terrain, en Next.js, Firebase, TypeScript et Tailwind CSS." },
			{ name: 'Novaccord', text: "site vitrine d'une société de médiation, qui présente son accompagnement dans la prévention et la résolution des conflits entre professionnels." },
		],
		approach:
			"Nous partons de votre besoin, proposons une architecture simple, livrons par itérations courtes et documentons le code. Le référencement et les performances sont traités dès la conception, pas après coup.",
		faq: [
			{ q: "Quelles technologies utilisez-vous pour les applications web ?", a: "Sur nos réalisations, nous utilisons principalement Next.js, React, TypeScript, Tailwind CSS et Firebase. Le choix final dépend de votre besoin." },
			{ q: "Le référencement est-il pris en compte ?", a: "Oui : le SEO et la performance font partie de notre offre web et sont pensés dès la conception du site." },
			{ q: "Comment démarrer un projet ?", a: "Écrivez-nous en décrivant votre besoin, même sommairement, par le formulaire du site ou par e-mail. Nous revenons vers vous avec des questions et une proposition." },
		],
	},
	{
		slug: 'applications-mobiles',
		name: 'Applications mobiles iOS et Android',
		h1: 'Développement d\'applications mobiles iOS et Android en Île-de-France',
		metaTitle: "Applications mobiles iOS et Android en Île-de-France",
		metaDescription:
			"Studio de développement d'applications mobiles iOS et Android en Île-de-France : React Native, Flutter et Swift natif, de la maquette à l'App Store. Contactez Kuba Studio.",
		intro:
			"Kuba Studio développe des applications iOS et Android, natives ou cross-platform, pour les entreprises, associations et porteurs de projet d'Île-de-France. Nous vous accompagnons de la maquette jusqu'à la publication sur les stores.",
		detail:
			"Nous prenons en charge l'ensemble du parcours : cadrage du besoin, design de l'interface, développement, tests puis mise en ligne. L'objectif est une application fluide, claire pour vos utilisateurs et simple à maintenir, que vous partiez d'une idée ou d'une maquette existante.",
		listTitle: 'Ce que nous réalisons',
		list: ['React Native et Flutter', 'Applications iOS et Android', 'Design UI/UX', 'Déploiement sur l\'App Store'],
		projectsTitle: 'Des réalisations concrètes',
		projects: [
			{ name: 'Coasso', text: "application des adhérents d'associations (web, iOS et Android, en bêta), développée avec Flutter : trouver un club, s'inscrire et payer sa cotisation en ligne." },
			{ name: 'Picstat', text: "application de montage photo et vidéo avec overlays issus des activités Strava, en React Native et Expo." },
			{ name: 'Tivea', text: "application Mac, iPad et iPhone de gestion financière, en Swift et SwiftUI, disponible sur l'App Store." },
		],
		approach:
			"Natif ou cross-platform : nous choisissons selon votre besoin, pas par habitude. Tivea est native en Swift, Picstat en React Native et Coasso en Flutter.",
		faq: [
			{ q: "Application native ou cross-platform ?", a: "Nous maîtrisons les deux. Le cross-platform (React Native, Flutter) permet de couvrir iOS et Android avec une base commune ; le natif (Swift) convient quand l'intégration à la plateforme est centrale." },
			{ q: "Vous occupez-vous de la publication sur l'App Store ?", a: "Oui, le déploiement App Store fait partie de notre accompagnement. Tivea, notre application, y est publiée." },
			{ q: "Comment démarrer ?", a: "Écrivez-nous avec une description de votre idée ou de votre projet en cours ; nous reviendrons vers vous avec des questions puis une proposition." },
		],
	},
	{
		slug: 'logiciels-sur-mesure',
		name: 'Logiciels sur mesure',
		h1: 'Développement de logiciels sur mesure en Île-de-France',
		metaTitle: 'Logiciels sur mesure en Île-de-France',
		metaDescription:
			"Développement de logiciels sur mesure en Île-de-France : APIs REST et GraphQL, logiciels desktop, automatisations et intégrations adaptés à vos processus métier. Kuba Studio.",
		intro:
			"Quand les outils du marché ne collent pas à vos processus, Kuba Studio développe des logiciels sur mesure pour les entreprises, associations et indépendants d'Île-de-France : APIs, logiciels desktop, automatisations et intégrations avec vos outils existants.",
		detail:
			"Un logiciel sur mesure peut remplacer des tâches manuelles répétitives, relier plusieurs outils entre eux ou structurer un processus propre à votre activité. Nous veillons à la sécurité des données et à la simplicité d'usage, pour que l'outil soit réellement adopté par ceux qui s'en servent. Nous livrons par étapes, pour que vous puissiez tester et ajuster en cours de route.",
		listTitle: 'Ce que nous réalisons',
		list: ['APIs REST et GraphQL', 'Logiciels desktop', 'Automatisations', 'Intégrations tierces'],
		projectsTitle: 'Des réalisations concrètes',
		projects: [
			{ name: 'Tivea', text: "logiciel Mac, iPad et iPhone de gestion financière (achats, encaissements, comptes bancaires, TVA) dont les données sont chiffrées et restent chez l'utilisateur." },
			{ name: 'Coasso', text: "une API en Go avec base PostgreSQL et paiements Stripe au service des applications web et mobiles." },
		],
		approach:
			"Nous cadrons d'abord le besoin avec vous, livrons une première version utilisable rapidement, puis itérons. Code propre, architecture solide, documentation et tests à chaque étape.",
		faq: [
			{ q: "Quand choisir un logiciel sur mesure ?", a: "Lorsque vos processus métier sont spécifiques et qu'aucun outil existant ne les couvre sans contournements. Nous pouvons en discuter avec vous avant tout engagement." },
			{ q: "Pouvez-vous connecter vos développements à nos outils existants ?", a: "Oui, les APIs et les intégrations tierces font partie de nos services." },
			{ q: "Comment démarrer ?", a: "Décrivez-nous le processus à améliorer par le formulaire ou par e-mail ; nous revenons vers vous avec des questions et une proposition." },
		],
	},
	{
		slug: 'plateformes-saas',
		name: 'Plateformes SaaS',
		h1: 'Création de plateformes SaaS en Île-de-France',
		metaTitle: 'Création de plateformes SaaS en Île-de-France',
		metaDescription:
			"Kuba Studio crée des plateformes SaaS en Île-de-France : architecture cloud, multi-tenant, facturation et abonnements, monitoring. De l'idée au produit en ligne.",
		intro:
			"Kuba Studio conçoit et lance des plateformes SaaS : architecture cloud scalable, multi-tenant, facturation et abonnements. Nous accompagnons les porteurs de projet et entreprises d'Île-de-France de l'idée jusqu'au produit en ligne.",
		detail:
			"Un SaaS ne se limite pas à une interface : il faut gérer les comptes et les rôles, la sécurité des données, l'hébergement, l'encaissement et la montée en charge. Nous couvrons ces sujets dès la conception pour que votre produit puisse accueillir ses premiers clients puis grandir sans refonte.",
		listTitle: 'Ce que nous réalisons',
		list: ['Architecture cloud', 'Multi-tenant', 'Scalabilité et monitoring', 'Facturation et abonnements'],
		projectsTitle: 'Une réalisation concrète',
		projects: [
			{ name: 'Coasso Pro', text: "outil de gestion pour les dirigeants d'associations sportives, culturelles et solidaires (en bêta) : adhérents et inscriptions, paiements en ligne encaissés directement par l'association via Stripe Connect, planning, formulaires, messagerie et rôles. Flutter, Go et Cloud Run ; conforme RGPD, données hébergées en Europe." },
		],
		approach:
			"Nous développons aussi nos propres produits : nous connaissons donc les contraintes d'un SaaS en production, de la gestion des comptes à l'encaissement des abonnements.",
		faq: [
			{ q: "Qu'est-ce qu'une architecture multi-tenant ?", a: "Une même plateforme sert plusieurs clients (par exemple plusieurs associations) dont les données restent séparées. C'est la base d'un SaaS qui peut grandir." },
			{ q: "Gérez-vous la facturation et les abonnements ?", a: "Oui, la facturation et les abonnements font partie de notre offre ; sur Coasso Pro, nous utilisons Stripe Connect pour que chaque association encaisse directement ses paiements." },
			{ q: "Comment démarrer ?", a: "Présentez-nous votre idée par le formulaire ou par e-mail ; nous revenons vers vous avec des questions et une proposition." },
		],
	},
];
